"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHiddenPropName = getHiddenPropName;
exports.getVisibilityChangeEventName = getVisibilityChangeEventName;
// Set the name of the hidden property and the change event for the Page Visibility API
var hidden;
var visibilityChange;

if ('hidden' in document) {
  hidden = 'hidden';
  visibilityChange = 'visibilitychange';
} else if ('msHidden' in document) {
  hidden = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if ('webkitHidden' in document) {
  hidden = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
} else if ('mozHidden' in document) {
  hidden = 'mozHidden';
  visibilityChange = 'mozvisibilitychange';
} else if ('oHidden' in document) {
  hidden = 'oHidden';
  visibilityChange = 'ovisibilitychange';
} else {// The API must not be supported in this browser.
}

function getHiddenPropName() {
  return hidden;
}

function getVisibilityChangeEventName() {
  return visibilityChange;
}